import React from "react";
import styled from "styled-components";

const SquareFilledButtonContainer = styled.button`
  background-color: ${({ theme }) => theme.greenLight};
  color: #fff;
  padding: 15px 20px;
  border: none;
  border-radius: 50px;
  width: 235px;
  height: 56px;
  padding: 10px 0px 0px 0px;
  border-radius: 3px;

  cursor: pointer;
  /* height: 34px; */
  text-align: center;
  border: 1px solid #38d8ab;
  font-size: 18px;
  font-weight: 500;
  box-shadow: 0px 16.4869px 25.3191px rgba(0, 0, 0, 0.06);
  transition: background-color 0.3s, box-shadow 0.3s;

  @media (max-width: 992px) {
    width: 250px;
    height: 48px;
    font-size: 16px;
  }

  @media (max-width: 768px) {
    width: 200px;
    height: 48px;
    font-size: 14px;
  }

  @media (max-width: 576px) {
    width: 180px;
    height: 48px;
    padding: 10px 15px;
  }

  &:hover {
    background-color: ${({ theme }) => theme.greenDark};
  }
`;

const SquareFilledButton = ({ btnText, handleClick }) => {
  return (
    <SquareFilledButtonContainer onClick={handleClick}>
      {btnText}
    </SquareFilledButtonContainer>
  );
};

export default SquareFilledButton;
